import React from 'react';

interface ReasoningModalProps {
    open: boolean;
    onClose: () => void;
    srcLabel: string;
    tgtLabel: string;
    reasoning: string;
}

export const ReasoningModal: React.FC<ReasoningModalProps> = ({ open, onClose, srcLabel, tgtLabel, reasoning }) => {
    if (!open) return null;
    return (
        <div
            onClick={onClose}
            className="mapper-ui font-sans fixed inset-0 flex items-center justify-center z-[100] p-5"
            style={{ background: 'rgba(24,33,48,.42)' }}
        >
            <div
                onClick={e => e.stopPropagation()}
                className="bg-mapper-white rounded-2xl max-w-[520px] w-full overflow-hidden shadow-mapper-modal"
            >
                <div className="px-6 py-5 border-b border-mapper-border-3 flex items-center justify-between">
                    <div className="flex items-center gap-[9px]">
                        <div className="w-7 h-7 rounded-lg bg-mapper-teal-bg-2 flex items-center justify-center">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0E8577" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 3v3M12 18v3M3 12h3M18 12h3" /><circle cx="12" cy="12" r="3.2" />
                            </svg>
                        </div>
                        <h3 className="text-base font-bold m-0">Why Advital Sync suggested this</h3>
                    </div>
                    <button onClick={onClose} className="w-[30px] h-[30px] rounded-lg text-mapper-muted-3 text-xl flex items-center justify-center">×</button>
                </div>
                <div className="px-6 py-[22px]">
                    <div className="text-[13px] font-bold text-mapper-muted-3 tracking-[0.4px] mb-2">MAPPING</div>
                    <div className="flex items-center gap-[10px] mb-[18px] text-[14.5px] font-semibold">
                        <span>{srcLabel}</span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C2C9D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                        <span className="text-mapper-teal-hover">{tgtLabel}</span>
                    </div>
                    <div className="text-[13px] font-bold text-mapper-muted-3 tracking-[0.4px] mb-2">REASONING</div>
                    <p className="text-sm text-mapper-body-text-3 leading-[1.6] m-0">{reasoning}</p>
                </div>
            </div>
        </div>
    );
};
